import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import _isArray from "lodash/isArray";
import _uniqueId from "lodash/uniqueId";
import _isFunction from "lodash/isFunction";
import _omit from "lodash/omit";
import _isUndefined from "lodash/isUndefined";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';
import TableHead from './TableHead';
import TableBody from './TableBody';
import TablePagination from './TablePagination';
import { Skeleton, Spinner } from '../Loader';
import { TableNoResults } from './NoResults';
import { useUrlParams, useWindowSize } from '../hooks';
import { commonStyles } from '../styles';
import { tableContainer, filterBarContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var tableSystemProps = ['totalPages', 'totalResults'];

var filterColumnMore = function filterColumnMore(data, windowWidth) {
  if (data !== null && data !== void 0 && data.invisibleBelow && (data === null || data === void 0 ? void 0 : data.invisibleBelow) > windowWidth) return data;
};

var Table = /*#__PURE__*/forwardRef(function (props, reference) {
  var _ref, _urlQueryParams$pageS, _urlQueryParams$pageI;

  var getDataMethod = props.getDataMethod,
      _props$getDataKey = props.getDataKey,
      getDataKey = _props$getDataKey === void 0 ? 'data' : _props$getDataKey,
      columns = props.columns,
      pageSize = props.pageSize,
      emptyMessageProp = props.emptyMessage,
      FilterBar = props.filterBar,
      footerBar = props.footerBar,
      className = props.className,
      updateOn = props.updateOn,
      onSelect = props.onSelect,
      hasPagination = props.hasPagination,
      hasSelectionProp = props.hasSelection,
      pageSizes = props.pageSizes,
      _props$showLoader = props.showLoader,
      showLoader = _props$showLoader === void 0 ? true : _props$showLoader,
      _props$fillUpUrlParam = props.fillUpUrlParams,
      fillUpUrlParams = _props$fillUpUrlParam === void 0 ? true : _props$fillUpUrlParam,
      renderRow = props.renderRow,
      onRowClick = props.onRowClick,
      rowLink = props.rowLink;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useWindowSize = useWindowSize(),
      windowWidth = _useWindowSize.width;

  var _useState3 = useState(emptyMessageProp !== null && emptyMessageProp !== void 0 ? emptyMessageProp : 'There are no results.'),
      _useState4 = _slicedToArray(_useState3, 2),
      emptyMessage = _useState4[0],
      setEmptyMessage = _useState4[1];

  var hasSelection = _isFunction(onSelect) || hasSelectionProp;
  var loaderRef = useRef();

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams,
      setUrlQueryParams = _useUrlParams.setUrlQueryParams;

  var isInitialMount = data === null;
  var columnsMore = columns.filter(function (el) {
    return filterColumnMore(el, windowWidth);
  });
  var tableOptions = useRef(_objectSpread(_objectSpread({}, hasPagination && {
    pageSize: parseInt((_ref = (_urlQueryParams$pageS = urlQueryParams.pageSize) !== null && _urlQueryParams$pageS !== void 0 ? _urlQueryParams$pageS : pageSize) !== null && _ref !== void 0 ? _ref : 10, 10),
    pageIndex: parseInt((_urlQueryParams$pageI = urlQueryParams.pageIndex) !== null && _urlQueryParams$pageI !== void 0 ? _urlQueryParams$pageI : 0, 10),
    totalPages: 1,
    totalResults: 0
  }), {}, {
    sort: urlQueryParams.sort
  }));
  useImperativeHandle(reference, function () {
    return {
      tableOptions: tableOptions,
      getData: function getData(params) {
        return _getData(params);
      },
      selectRow: function selectRow(row) {
        return _selectRow(row);
      },
      changeEmptyMessage: setEmptyMessage
    };
  });
  useEffect(function () {
    !FilterBar && _getData();
  }, _isArray(updateOn) ? updateOn : [updateOn]);

  var _getData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _loaderRef$current, _loaderRef$current2;

      var options,
          requestOptions,
          _yield$getDataMethod,
          _yield$getDataMethod2,
          res,
          err,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              tableOptions.current = _objectSpread(_objectSpread(_objectSpread({}, tableOptions.current), options), _isUndefined(options.pageIndex) && !isInitialMount && {
                pageIndex: 0,
                totalPages: 1
              });
              requestOptions = _omit(tableOptions.current, tableSystemProps); // Wrap all filters into spinner to indicate that results are coming

              !isInitialMount && showLoader && ((_loaderRef$current = loaderRef.current) === null || _loaderRef$current === void 0 ? void 0 : _loaderRef$current.showLoading());
              _context.next = 6;
              return getDataMethod(requestOptions);

            case 6:
              _yield$getDataMethod = _context.sent;
              _yield$getDataMethod2 = _slicedToArray(_yield$getDataMethod, 2);
              res = _yield$getDataMethod2[0];
              err = _yield$getDataMethod2[1];
              !isInitialMount && showLoader && ((_loaderRef$current2 = loaderRef.current) === null || _loaderRef$current2 === void 0 ? void 0 : _loaderRef$current2.hideLoading());

              if (!err) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return", setData([]));

            case 13:
              tableOptions.current.totalPages = Math.ceil((res === null || res === void 0 ? void 0 : res.total) / tableOptions.current.pageSize) || 1;
              tableOptions.current.totalResults = res === null || res === void 0 ? void 0 : res.total;
              setData(res ? res[getDataKey].map(function (el) {
                return _objectSpread(_objectSpread({}, el), {}, {
                  _table: {
                    isSelected: false,
                    uuid: _uniqueId()
                  }
                });
              }) : []); // By default all request options will be save into the ulr, so all filters can be kept

              fillUpUrlParams && setUrlQueryParams(requestOptions);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function _getData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var clearTableData = function clearTableData() {
    tableOptions.current = _objectSpread(_objectSpread({}, tableOptions.current), {}, {
      totalPages: 1,
      totalResults: 0,
      pageIndex: 0
    });
    setData([]);
  };

  var _selectRow = function _selectRow(value, row) {
    // If row is not passed mark all rows from the table
    var compare = function compare(el) {
      return !row || el._table.uuid === row._table.uuid;
    };

    setData(function (prev) {
      var newRows = prev.map(function (el) {
        return compare(el) ? _objectSpread(_objectSpread({}, el), {}, {
          _table: _objectSpread(_objectSpread({}, el._table), {}, {
            isSelected: value
          })
        }) : el;
      });
      _isFunction(onSelect) && onSelect(newRows.filter(function (el) {
        return el._table.isSelected;
      }));
      return newRows;
    });
  };

  var tableDataProps = {
    tableOptions: tableOptions,
    getData: _getData,
    data: data,
    setData: setData,
    selectRow: _selectRow,
    setEmptyMessage: setEmptyMessage,
    clearTableData: clearTableData
  };
  return ___EmotionJSX("div", {
    css: commonStyles(props)
  }, ___EmotionJSX("div", _extends({
    css: tableContainer
  }, className && {
    className: className
  }), FilterBar && ___EmotionJSX("div", {
    css: filterBarContainer
  }, ___EmotionJSX(Spinner, {
    ref: loaderRef
  }), FilterBar(tableDataProps)), ___EmotionJSX(TableHead, _extends({
    hasSelection: hasSelection,
    columns: columns,
    allSelected: data === null || data === void 0 ? void 0 : data.every(function (el) {
      var _el$_table;

      return el === null || el === void 0 ? void 0 : (_el$_table = el._table) === null || _el$_table === void 0 ? void 0 : _el$_table.isSelected;
    })
  }, tableDataProps)), (data === null || data === void 0 ? void 0 : data.length) === 0 ? ___EmotionJSX(TableNoResults, {
    emptyMessage: emptyMessage
  }) : !data ? ___EmotionJSX(Skeleton, {
    count: tableOptions.current.pageSize,
    height: 35,
    margin: "1em 2em",
    width: "auto"
  }) : ___EmotionJSX(TableBody, _extends({
    hasSelection: hasSelection,
    data: data,
    columns: columns,
    columnsMore: columnsMore,
    renderRow: renderRow,
    onRowClick: onRowClick,
    rowLink: rowLink
  }, tableDataProps))), hasPagination && ___EmotionJSX(TablePagination, _extends({}, tableDataProps, {
    pageSizes: pageSizes
  })), footerBar && footerBar(tableDataProps));
});
Table.propTypes = {
  getDataMethod: PropTypes.func,
  columns: PropTypes.array,
  pageSize: PropTypes.number,
  emptyMessage: PropTypes.string,
  filterBar: PropTypes.func,
  footerBar: PropTypes.func,
  updateOn: PropTypes.any,
  className: PropTypes.string,
  getDataKey: PropTypes.string,
  onSelect: PropTypes.func,
  hasPagination: PropTypes.bool,
  hasSelection: PropTypes.bool,
  pageSizes: PropTypes.array,
  showLoader: PropTypes.bool,
  fillUpUrlParams: PropTypes.bool,
  renderRow: PropTypes.func,
  onRowClick: PropTypes.func,
  rowLink: PropTypes.any
};
export default Table;